import React from "react";
import Header from "../../Header1";
import Footer from "../../Footer2";
import PageTitle from "./PageTitle";
import ErrorContent from "./ErrorContent";

const Error404 = () => {
	return (
		<>
			<Header />
			<PageTitle />
			<ErrorContent />
			<Footer />
		</>
	);
};
export default Error404;
